// Casanova Barbier - Translations
const translations = {
  fr: {
    // Per-page SEO strings (titles get " · Casanova Salon Barbier" appended automatically)
    seo: {
      home: {
        title: "Barbier haut de gamme à la Petite-Italie",
        description:
          "L'art du barbier italien au cœur de la Petite-Italie, Montréal. Coupes, rasages à la serviette chaude, soins de barbe. Réservez chez Casanova.",
      },
      services: {
        title: "Nos services",
        description:
          "The Cut, À la Casanova, The Beard, The Head Shave, Bambini. Tarifs par barbier, incluant l'expertise maître de Pasqualino.",
      },
      team: {
        title: "Notre équipe",
        description:
          "Rencontrez Pasqualino Dachille, Francesco Pizzi et les barbiers de Casanova — des artisans formés à Vidal Sassoon, Proraso et Scoring Barbier.",
      },
      gallery: {
        title: "Galerie",
        description:
          "Coupes, rasages, ambiance. Un journal visuel de Casanova Salon Barbier, de 2021 à aujourd'hui.",
      },
      clientele: {
        title: "Le Cercle",
        description:
          "Une communauté organisée d'hommes accueillis chez Casanova. Demandez à être présenté.",
      },
      booking: {
        title: "Rendez-vous",
        description:
          "Prenez ou gérez vos rendez-vous chez Casanova Salon Barbier. Choisissez votre service, votre barbier et votre moment — confirmation immédiate.",
      },
      contact: {
        title: "Contact",
        description:
          "56 rue Jean-Talon Ouest, Petite-Italie, Montréal. Téléphone (514) 227-2366. Heures d'ouverture, itinéraire et carte.",
      },
    },

    // Navigation
    nav: {
      home: "Accueil",
      services: "Services",
      team: "Équipe",
      gallery: "Galerie",
      clientele: "Le Cercle",
      booking: "Rendez-vous",
      contact: "Contact",
      bookNow: "Rendez-vous"
    },
    
    // Hero
    hero: {
      headline: "L'art du barbier italien.",
      subheadline: "Une expérience de soins premium dans le cœur de la Petite-Italie, Montréal.",
      cta: "Rendez-vous",
      ctaSecondary: "Nos services",
      badge: "Est. 2020 · Petite-Italie · MTL"
    },
    
    // Pillars (Commitments)
    pillars: {
      title: "Notre engagement",
      intro: "Cinq promesses qui guident chaque visite chez Casanova.",
      items: [
        {
          title: "Votre expérience, c'est tout.",
          body: "Du moment où vous franchissez la porte jusqu'à celui où vous repartez, chaque détail est pensé. Ce n'est pas qu'une coupe — c'est un moment qui vous appartient."
        },
        {
          title: "On ne laisse rien au hasard.",
          body: "La façon dont la cape est posée. La chaleur de la serviette. La musique dans la pièce. Ici, rien n'est laissé au hasard."
        },
        {
          title: "On évolue pour que vous n'ayez pas à y penser.",
          body: "Les tendances changent. Les techniques avancent. On garde une longueur d'avance pour qu'à chaque visite, vous repartiez avec le meilleur de ce qui se fait."
        },
        {
          title: "On écoute avant de toucher.",
          body: "Votre vision guide tout. On pose les bonnes questions, on comprend, on retient — parce qu'un excellent résultat commence bien avant que les ciseaux entrent en jeu."
        },
        {
          title: "Laissez le monde dehors.",
          body: "Casanova, c'est votre moment. Un espace conçu pour les hommes qui apprécient le rare plaisir de se faire prendre en charge — complètement."
        }
      ]
    },
    
    // Story
    story: {
      overline: "Notre histoire",
      title: "Une vision née de la passion",
      p1: "Le nom Casanova évoque Giacomo Casanova — non pas le séducteur, mais l'homme de la Renaissance impeccablement présenté, qui naviguait dans la société européenne avec charisme et raffinement.",
      p2: "Fondé en 2020 par Pasqualino Dachille et Francesco Pizzi, Casanova Salon Barbier est né d'une vision commune : apporter un barbier de classe mondiale au cœur de la Petite-Italie de Montréal.",
      p3: "Chaque visite chez Casanova est un rituel de préparation pour votre propre monde social. De nos fondateurs à nos barbiers, nous mettons beaucoup d'amour et de soin dans tout ce que nous faisons.",
      quote: "« From our founders to our front-line barbers, we put lots of love and careful thought into all we do. »"
    },

    // Storefront
    storefront: {
      eyebrow: "Notre adresse",
      addressLine1: "56 rue Jean-Talon Ouest",
      addressLine2: "Petite-Italie, Montréal",
      caption: "Un sanctuaire pour l'homme moderne, au cœur de la Petite-Italie depuis 2020.",
    },

    // Reviews
    reviews: {
      eyebrow: "Ce que disent les clients",
      title: "Avis Google · en direct",
      intro: "Témoignages authentiques, mis à jour depuis notre fiche Google.",
      ago: "il y a",
      fallback: "Chargement des avis…",
      viewAllLabel: "Voir tous les avis sur Google",
    },
    
    // Services
    services: {
      title: "Nos services",
      subtitle: "Des soins sur mesure pour l'homme moderne",
      signatureLabel: "Service signature",
      priceNote: "Les tarifs varient selon le barbier. Les services avec Pasqualino reflètent son expertise de maître et ses certifications internationales.",
      bookThis: "Réserver",
      signature: "Signature",
      duration: "min",
      standard: "Standard",
      byPasqualino: "Par Pasqualino",
      copy: {
        eyebrow: "Plus qu'un barbier",
        title: "Casanova Salon Barbier — Le soin masculin de prestige au cœur de la Petite-Italie",
        paragraphs: [
          "Situé au cœur de la Petite-Italie, Casanova Salon Barbier est la référence montréalaise pour le soin capillaire masculin haut de gamme. Des coupes de précision aux rasages au coupe-chou, en passant par la mise en forme de barbe et les soins du cuir chevelu, chaque prestation est réalisée par une équipe de barbiers chevronnés, formés aux quatre coins du monde.",
          "Notre équipe puise son expertise sur trois continents — des ateliers de Vidal Sassoon à Toronto, aux cours de rasage traditionnels à Florence, en passant par les barbershops d'avant-garde de Rotterdam. Cette expérience internationale se reflète dans chaque coupe, chaque geste, et dans un niveau d'exigence difficile à trouver ailleurs à Montréal.",
          "Que vous soyez un habitué en quête de votre coupe signature ou un nouveau client qui cherche une expérience plus soignée, Casanova propose bien plus qu'un simple service : un rituel, une ambiance, un standard. C'est l'endroit où le métier est pratiqué avec rigueur et où vous repartez, à chaque fois, avec l'assurance du travail bien fait.",
          "Prenez rendez-vous en ligne et rejoignez une clientèle croissante de professionnels, créatifs et hommes exigeants qui font confiance à Casanova Salon Barbier.",
        ],
        address: "56 rue Jean-Talon Ouest, Montréal — Petite-Italie",
        cta: "Prendre rendez-vous",
      },
      items: {
        theCutJunior: {
          name: 'The Cut "Junior"',
          description: "Service de coupe complet pour les jeunes clients à un prix accessible."
        },
        theCut: {
          name: "The Cut",
          description: "Coupe complète et consultation comprenant un shampooing, un rinçage, un coiffage et une éducation personnalisée selon vos cheveux."
        },
        alaCasanova: {
          name: "À la Casanova",
          description: "L'expérience Casanova complète combinant The Cut et The Beard. Notre service phare."
        },
        theBeard: {
          name: "The Beard",
          description: "Une consultation suivie d'une restructuration complète de la barbe avec rasage à la serviette chaude ou contour, terminée par un lavage et conditionnement rafraîchissant."
        },
        theHeadShave: {
          name: "The Head Shave",
          description: "Une expérience de détente ultime. Gommage exfoliant suivi d'une mousse chaude, d'une serviette vapeur et d'un rasage de précision."
        },
        bambini: {
          name: "Bambini",
          description: "Une coupe professionnelle pour les jeunes hommes de 12 ans et moins."
        }
      }
    },
    
    // Team
    team: {
      title: "Notre équipe",
      subtitle: "Des artisans passionnés au service de votre style",
      philosophy: "« De nos fondateurs à nos barbiers, nous mettons beaucoup d'amour et de soin dans tout ce que nous faisons. Notre objectif : vous offrir le meilleur, à chaque visite. »",
      cofounder: "Co-fondateur",
      masterBarber: "Maître Barbier",
      barber: "Barbier",
      certifications: "Certifications",
      pasqualino: {
        name: "Pasqualino Joey Dachille",
        role: "Co-fondateur & Maître Barbier",
        bio: "Mon parcours dans le métier de barbier n'a rien eu de conventionnel. Pas d'école, pas de programme structuré. Ça a commencé comme les meilleures choses dans la vie — en me présentant. Chaque jour."
      },
      francesco: {
        name: "Francesco Pizzi",
        role: "Co-fondateur",
        bio: "Visionnaire et entrepreneur, Francesco a cofondé Casanova avec la mission d'offrir une expérience de barbier exceptionnelle à Montréal."
      },
      teamMembers: {
        cherry: { name: "Francesco \"Cherry\" Cerasuolo", role: "Barbier", specialty: "Coupes classiques & modernes" },
        lenny: { name: "Lenny", role: "Barbier", specialty: "Fades & styles contemporains" },
        marco: { name: "Marco", role: "Barbier", specialty: "Barbes & rasages traditionnels" },
        sara: { name: "Sara", role: "Barbier", specialty: "Coupes texturées & créatives" }
      }
    },
    
    // Gallery
    gallery: {
      title: "Galerie",
      subtitle: "Un aperçu de l'expérience Casanova",
      categories: {
        classic: "Coupes classiques",
        shaves: "Rasages",
        beards: "Travail de barbe",
        atmosphere: "Ambiance du salon",
        details: "Détails"
      },
      placeholder: "Bientôt disponible"
    },
    
    // The Circle by Casanova
    clientele: {
      title: "Le Cercle",
      titleSuffix: "par Casanova",
      eyebrow: "LE CERCLE",
      membersEyebrow: "Nos membres",
      subtitle: "Chez Casanova, nous accueillons des hommes de tous horizons. Le Cercle est notre façon de vous rendre hommage — et de vous connecter.",
      note: "Le Cercle est une communauté organisée. Toutes les présentations sont examinées et approuvées par Casanova.",
      ctaTitle: "Vous voulez faire partie du Cercle ?",
      ctaButton: "Demander à rejoindre",
      requestTitle: "Demander à être présenté",
      categoryLabel: "Catégorie",
      categoryAll: "Toutes les catégories",
      noCategoryMatchTitle: "Personne dans cette catégorie pour l'instant.",
      noCategoryMatchBody: "Revenez bientôt ou explorez une autre catégorie.",
      profileBack: "Le Cercle",
      profileAbout: "À propos",
      profileAtCasanova: "Chez Casanova",
      profileProfessionSpecialty: "Profession & Spécialité",
      profileSpecialty: "Spécialité",
      profileRelationship: "Avec Casanova",
      profileConnect: "Contact",
      profileNoSocial: "Sur invitation",
      emptyTitle: "Le Cercle s'écrit en silence.",
      emptyBody: "Nos premiers membres sont en cours d'examen. Revenez bientôt — ou demandez à être présenté.",
      requestTitle: "Demander à être présenté",
      form: {
        name: "Nom complet",
        email: "Courriel",
        profession: "Profession",
        specialty: "Votre spécialité (2-3 phrases)",
        social: "LinkedIn ou Instagram (optionnel)",
        consent: "J'accepte d'être présenté sur le site de Casanova",
        submit: "Soumettre ma demande",
        success: "Votre demande a été soumise avec succès!"
      }
    },
    
    // Booking
    booking: {
      title: "Rendez-vous",
      subtitle: "Prenez votre rendez-vous en ligne en quelques clics",
      manageBanner: "Vous avez déjà un rendez-vous ? Faites défiler jusqu'en bas pour le consulter, le modifier ou l'annuler.",
      manage: {
        eyebrow: "Déjà réservé ?",
        title: "Gérez votre rendez-vous",
        intro: "Entrez votre courriel — nous vous enverrons un lien sécurisé pour consulter, modifier ou annuler votre prochaine visite.",
        emailPlaceholder: "votre@courriel.com",
        cta: "Envoyer le lien",
        sending: "Envoi…",
        sent: "Si un rendez-vous existe pour ce courriel, un lien de gestion a été envoyé. Vérifiez votre boîte courriel.",
        errorGeneric: "Une erreur est survenue. Veuillez réessayer.",
        managePageTitle: "Votre rendez-vous",
        managePageIntro: "Bonjour {name}. Voici vos prochains rendez-vous chez Casanova.",
        noBookings: "Aucun rendez-vous à venir. Envie d'en réserver un ?",
        bookNow: "Réserver maintenant",
        with: "avec",
        cancel: "Annuler",
        reschedule: "Modifier",
        cancelConfirmTitle: "Annuler ce rendez-vous ?",
        cancelConfirmBody: "Cette action est immédiate et ne peut être annulée.",
        cancelConfirmCta: "Oui, annuler",
        keepIt: "Garder le rendez-vous",
        cancelled: "Rendez-vous annulé.",
        rescheduleTitle: "Choisir un nouveau moment",
        rescheduleCta: "Confirmer le nouveau rendez-vous",
        rescheduled: "Rendez-vous modifié.",
        rescheduleNoSlots: "Aucune disponibilité avec ce barbier dans les 30 prochains jours. Appelez-nous et nous trouverons un moment.",
        invalidOrExpired: "Ce lien n'est plus valide. Demandez-en un nouveau depuis la page de réservation.",
        backToBooking: "Retour à la réservation",
      },
      squarePlaceholder: "Widget de réservation Square",
      squareNote: "Le système de réservation sera configuré prochainement.",
      squareCta: {
        eyebrow: "Réservation en ligne",
        title: "Réservez votre rendez-vous",
        body: "Choisissez votre service, votre barbier et votre moment sur notre plateforme de réservation sécurisée Square. Confirmation immédiate par courriel.",
        points: [
          "Confirmation immédiate par courriel",
          "Rappel automatique avant votre visite",
          "Modifiez ou annulez en un clic",
        ],
        cta: "Réserver maintenant",
        opensNew: "S'ouvre dans un nouvel onglet · Sécurisé par Square",
        phoneLabel: "Ou appelez-nous :",
      },
      hoursTitle: "Heures d'ouverture",
      hours: {
        monday: "Lundi",
        tuesday: "Mardi",
        wednesday: "Mercredi",
        thursday: "Jeudi",
        friday: "Vendredi",
        saturday: "Samedi",
        sunday: "Dimanche",
        closed: "Fermé"
      },
      addressTitle: "Adresse",
      address: "56 rue Jean-Talon Ouest",
      neighborhood: "Petite-Italie, Montréal, QC H2R 2W7",
      paymentsTitle: "Modes de paiement",
      faqTitle: "Questions fréquentes",
      flow: {
        step: "Étape",
        of: "sur",
        back: "Retour",
        next: "Suivant",
        confirm: "Confirmer la réservation",
        chooseService: "Choisissez votre service",
        chooseBarber: "Choisissez votre barbier",
        anyBarber: "Premier disponible",
        chooseTime: "Choisissez votre moment",
        yourDetails: "Vos coordonnées",
        firstName: "Prénom",
        lastName: "Nom",
        email: "Courriel",
        phone: "Téléphone",
        noteOptional: "Note (facultatif)",
        notePlaceholder: "Préférences, allergies, style souhaité…",
        minutes: "min",
        from: "à partir de",
        loading: "Chargement…",
        noSlots: "Aucune plage disponible pour cette date. Essayez un autre jour.",
        changeDate: "Changer de date",
        summary: "Votre rendez-vous",
        with: "avec",
        bookingError: "Une erreur s'est produite. Veuillez réessayer.",
        slotTaken: "Ce créneau vient tout juste d'être réservé par quelqu'un d'autre. Veuillez choisir une autre plage horaire.",
        confirmedTitle: "Confirmé",
        confirmedBody: "Nous vous avons envoyé une confirmation par courriel. À très bientôt chez Casanova.",
        bookAnother: "Prendre un autre rendez-vous",
      },
    },
    
    // FAQ
    faq: [
      {
        q: "Est-ce que je dois prendre rendez-vous?",
        a: "Oui, nous fonctionnons sur rendez-vous pour vous garantir le meilleur service sans attente. Réservez en ligne via notre système de réservation."
      },
      {
        q: "Combien de temps dure une coupe?",
        a: "Une coupe standard (The Cut) dure environ 45 minutes. Notre service signature À la Casanova dure 1 heure complète."
      },
      {
        q: "Qu'est-ce que le service À la Casanova?",
        a: "À la Casanova est notre service phare combinant The Cut et The Beard — l'expérience Casanova complète pour les hommes qui veulent le meilleur."
      },
      {
        q: "Pourquoi certains services coûtent-ils plus cher avec Pasqualino?",
        a: "Pasqualino possède une formation internationale certifiée (Vidal Sassoon Toronto, Scoring Barbier Rotterdam, Proraso Italie). Ses tarifs premium reflètent cette expertise unique."
      },
      {
        q: "Où est situé Casanova Barbier?",
        a: "Nous sommes au 56 rue Jean-Talon Ouest, dans le cœur de la Petite-Italie à Montréal. Facilement accessible en métro (Jean-Talon)."
      },
      {
        q: "Quels modes de paiement acceptez-vous?",
        a: "Nous acceptons Apple Pay, Google Pay, Interac, Visa, Mastercard, American Express, Discover et JCB."
      },
      {
        q: "Coupez-vous les cheveux des enfants?",
        a: "Oui! Notre service Bambini est conçu pour les jeunes hommes de 12 ans et moins."
      },
      {
        q: "Quel est le meilleur barbier de la Petite-Italie?",
        a: "Casanova Salon Barbier offre une expérience premium unique inspirée de la tradition italienne. Depuis 2021, nous sommes fiers d'être une référence dans le quartier."
      },
      {
        q: "Où Pasqualino a-t-il été formé?",
        a: "Pasqualino a été formé chez Vidal Sassoon (Toronto), Gradient (Toronto), Scoring Barbier (Rotterdam), Proraso (Italie), et Bloke Academy (Montréal)."
      }
    ],
    
    // Footer
    footer: {
      tagline: "L'art du barbier italien depuis 2020.",
      address: "56 rue Jean-Talon Ouest · Montréal, QC · Petite-Italie",
      copyright: "© 2020–2026 Casanova Salon Barbier. Tous droits réservés."
    },

    // Contact page
    contact: {
      eyebrow: "Restons en contact",
      title: "Nous rendre visite",
      intro: "Notre porte est ouverte. Passez nous voir, appelez-nous ou envoyez-nous un mot.",
      addressLabel: "Adresse",
      addressLine1: "56 rue Jean-Talon Ouest",
      addressLine2: "Petite-Italie, Montréal, QC H2R 2W7",
      directions: "Ouvrir dans Google Maps",
      phoneLabel: "Téléphone",
      phone: "(514) 227-2366",
      emailLabel: "Courriel",
      email: "ciaociao@casanovamtl.com",
      hoursLabel: "Heures d'ouverture",
      storefrontCaption: "56 Jean-Talon Ouest — sous l'auvent vert, au cœur de la Petite-Italie.",
      callCta: "Appeler",
      emailCta: "Écrire",
      directionsCta: "Itinéraire",
      days: {
        sun: "Dimanche",
        mon: "Lundi",
        tue: "Mardi",
        wed: "Mercredi",
        thu: "Jeudi",
        fri: "Vendredi",
        sat: "Samedi",
      },
    }
  },
  
  en: {
    // Per-page SEO strings (titles get " · Casanova Salon Barbier" appended automatically)
    seo: {
      home: {
        title: "Premium barbershop in Little Italy, Montreal",
        description:
          "The art of Italian barbering in the heart of Little Italy, Montreal. Haircuts, hot-towel shaves, beard work. Book your visit at Casanova.",
      },
      services: {
        title: "Our Services",
        description:
          "The Cut, À la Casanova, The Beard, The Head Shave, Bambini. Pricing by barber — including Pasqualino's master-level expertise.",
      },
      team: {
        title: "Our Team",
        description:
          "Meet Pasqualino Dachille, Francesco Pizzi and the Casanova barbers — craftsmen trained at Vidal Sassoon, Proraso and Scoring Barbier.",
      },
      gallery: {
        title: "Gallery",
        description:
          "Cuts, shaves, atmosphere. A visual journal of Casanova Salon Barbier, from 2021 to today.",
      },
      clientele: {
        title: "The Circle",
        description:
          "A curated community of men we welcome at Casanova. Request to be featured.",
      },
      booking: {
        title: "Appointments",
        description:
          "Make or manage your appointments at Casanova Salon Barbier. Pick your service, your barber and your time — instant confirmation.",
      },
      contact: {
        title: "Contact",
        description:
          "56 rue Jean-Talon Ouest, Little Italy, Montreal. Phone (514) 227-2366. Hours, directions and map.",
      },
    },

    // Navigation
    nav: {
      home: "Home",
      services: "Services",
      team: "Team",
      gallery: "Gallery",
      clientele: "The Circle",
      booking: "Appointments",
      contact: "Contact",
      bookNow: "Appointments"
    },
    
    // Hero
    hero: {
      headline: "The art of Italian barbering.",
      subheadline: "A premium grooming experience in the heart of Little Italy, Montreal.",
      cta: "Appointments",
      ctaSecondary: "Our Services",
      badge: "Est. 2020 · Little Italy · MTL"
    },
    
    // Pillars (Commitments)
    pillars: {
      title: "Our commitment",
      intro: "Five promises that shape every visit to Casanova.",
      items: [
        {
          title: "Your experience is everything.",
          body: "From the moment you walk in to the moment you leave, every detail is intentional. This is not just a haircut — it's time that belongs to you."
        },
        {
          title: "We sweat the small things.",
          body: "The way your cape is draped. The temperature of your towel. The music in the room. Nothing is an accident here."
        },
        {
          title: "We evolve so you don't have to think about it.",
          body: "Trends change. Techniques advance. We stay ahead so that when you sit in our chair, you're always getting the best of what's current."
        },
        {
          title: "We listen before we touch.",
          body: "Your vision drives everything. We ask, we understand, we remember — because a great result starts long before the scissors come out."
        },
        {
          title: "Leave the outside world outside.",
          body: "Casanova is your moment. A space built for men who appreciate the rare pleasure of being taken care of — completely."
        }
      ]
    },
    
    // Story
    story: {
      overline: "Our story",
      title: "A vision born from passion",
      p1: "The name Casanova evokes Giacomo Casanova — not the seducer, but the impeccably presented Renaissance man who navigated European society with charisma and refinement.",
      p2: "Founded in 2020 by Pasqualino Dachille and Francesco Pizzi, Casanova Salon Barbier was born from a shared vision: bringing world-class barbering to the heart of Montreal's Little Italy.",
      p3: "Every visit to Casanova is a ritual of preparation for your own social world. From our founders to our barbers, we put lots of love and careful thought into all we do.",
      quote: "\"From our founders to our front-line barbers, we put lots of love and careful thought into all we do.\""
    },

    // Storefront
    storefront: {
      eyebrow: "Our address",
      addressLine1: "56 rue Jean-Talon Ouest",
      addressLine2: "Little Italy, Montreal",
      caption: "A sanctuary for the modern man, at the heart of Little Italy since 2020.",
    },

    // Reviews
    reviews: {
      eyebrow: "What clients say",
      title: "Google reviews · live",
      intro: "Authentic testimonials, refreshed from our Google listing.",
      ago: "",
      fallback: "Loading reviews…",
      viewAllLabel: "See all reviews on Google",
    },
    
    // Services
    services: {
      title: "Our Services",
      subtitle: "Tailored grooming for the modern man",
      signatureLabel: "Signature service",
      priceNote: "Pricing varies by barber. Services with Pasqualino reflect his master-level expertise and international certifications.",
      bookThis: "Book Now",
      signature: "Signature",
      duration: "min",
      standard: "Standard",
      byPasqualino: "By Pasqualino",
      copy: {
        eyebrow: "More than a barbershop",
        title: "Casanova Salon Barbier — Premium Men's Grooming in Montreal's Little Italy",
        paragraphs: [
          "Located at the heart of Petite-Italie, Casanova Salon Barbier is Montreal's destination for refined men's barbering. From precision haircuts and classic straight razor shaves to beard sculpting and scalp treatments, every service is delivered by a team of seasoned barbers with international training and a passion for their craft.",
          "Our team brings expertise earned across three continents — from the cutting floors of Vidal Sassoon in Toronto, to the shaving ateliers of Florence, to the renowned barbershops of Rotterdam. That global experience translates into technique, attention to detail, and a standard of quality rarely found in a single chair, let alone a single shop.",
          "Whether you're a regular looking for your go-to cut or a first-time client seeking something more considered, Casanova offers a barbershop experience that goes beyond the service itself. This is a space where craft is taken seriously, where the ritual of grooming is respected, and where you leave looking and feeling the part.",
          "Book your appointment online and discover why a growing clientele of Montreal professionals, creatives, and discerning men trust Casanova Salon Barbier for their grooming needs.",
        ],
        address: "56 rue Jean-Talon Ouest, Montréal — Little Italy / Petite-Italie",
        cta: "Book your appointment",
      },
      items: {
        theCutJunior: {
          name: 'The Cut "Junior"',
          description: "Full haircut service for younger clients at an accessible price point."
        },
        theCut: {
          name: "The Cut",
          description: "Full haircut and consultation consisting of a shampoo, rinse, style and education personalized and tailored to you and your hair."
        },
        alaCasanova: {
          name: "À la Casanova",
          description: "The full Casanova experience consisting of The Cut and The Beard. Our flagship service."
        },
        theBeard: {
          name: "The Beard",
          description: "A consultation followed by a full beard re-shape with a hot towel shave or lineup, finished with a refreshing beard wash and condition."
        },
        theHeadShave: {
          name: "The Head Shave",
          description: "A great experience to sit back and be pampered. Exfoliating head scrub, hot foam lather, steamy towel, and precision shave."
        },
        bambini: {
          name: "Bambini",
          description: "A professional haircut for young men 12 and under."
        }
      }
    },
    
    // Team
    team: {
      title: "Our Team",
      subtitle: "Passionate craftsmen dedicated to your style",
      philosophy: "\"From our founders to our barbers, we put lots of love and careful thought into all we do. Our goal: to bring the best from us to you, every single visit.\"",
      cofounder: "Co-founder",
      masterBarber: "Master Barber",
      barber: "Barber",
      certifications: "Certifications",
      pasqualino: {
        name: "Pasqualino Joey Dachille",
        role: "Co-founder & Master Barber",
        bio: "My path into barbering wasn't conventional. No school enrollment, no structured curriculum. It started the way the best things in life usually do — by showing up. Every single day."
      },
      francesco: {
        name: "Francesco Pizzi",
        role: "Co-founder",
        bio: "Visionary and entrepreneur, Francesco co-founded Casanova with the mission to deliver an exceptional barbering experience in Montreal."
      },
      teamMembers: {
        cherry: { name: "Francesco \"Cherry\" Cerasuolo", role: "Barber", specialty: "Classic & modern cuts" },
        lenny: { name: "Lenny", role: "Barber", specialty: "Fades & contemporary styles" },
        marco: { name: "Marco", role: "Barber", specialty: "Beards & traditional shaves" },
        sara: { name: "Sara", role: "Barber", specialty: "Textured & creative cuts" }
      }
    },
    
    // Gallery
    gallery: {
      title: "Gallery",
      subtitle: "A glimpse into the Casanova experience",
      categories: {
        classic: "Classic Cuts",
        shaves: "Shaves",
        beards: "Beard Work",
        atmosphere: "Shop Atmosphere",
        details: "Details"
      },
      placeholder: "Coming Soon"
    },
    
    // The Circle by Casanova
    clientele: {
      title: "The Circle",
      titleSuffix: "by Casanova",
      eyebrow: "THE CIRCLE",
      membersEyebrow: "Our members",
      subtitle: "At Casanova, we welcome men from all walks of life. The Circle is our way of honouring you — and connecting you.",
      note: "The Circle is a curated community. All features are reviewed and approved by Casanova.",
      ctaTitle: "Want to be part of The Circle?",
      ctaButton: "Request to Join",
      requestTitle: "Request to be Featured",
      categoryLabel: "Category",
      categoryAll: "All categories",
      noCategoryMatchTitle: "No members in this category yet.",
      noCategoryMatchBody: "Come back soon, or explore another category.",
      profileBack: "The Circle",
      profileAbout: "About",
      profileAtCasanova: "At Casanova",
      profileProfessionSpecialty: "Profession & Specialty",
      profileSpecialty: "Specialty",
      profileRelationship: "With Casanova",
      profileConnect: "Connect",
      profileNoSocial: "By introduction",
      emptyTitle: "The Circle is written quietly.",
      emptyBody: "Our first members are being reviewed. Come back soon — or request to be introduced.",
      requestTitle: "Request to be Featured",
      form: {
        name: "Full Name",
        email: "Email",
        profession: "Profession",
        specialty: "What you specialize in (2-3 sentences)",
        social: "LinkedIn or Instagram (optional)",
        consent: "I consent to being featured on Casanova's website",
        submit: "Submit Request",
        success: "Your request has been submitted successfully!"
      }
    },
    
    // Booking
    booking: {
      title: "Appointments",
      subtitle: "Book your appointment online in just a few clicks",
      manageBanner: "Already have an appointment? Scroll to the bottom of this page to view, reschedule or cancel.",
      manage: {
        eyebrow: "Already booked?",
        title: "Manage your appointment",
        intro: "Enter your email — we'll send you a secure link to view, reschedule or cancel your upcoming visit.",
        emailPlaceholder: "your@email.com",
        cta: "Send link",
        sending: "Sending…",
        sent: "If an appointment exists for this email, a management link has been sent. Check your inbox.",
        errorGeneric: "Something went wrong. Please try again.",
        managePageTitle: "Your appointment",
        managePageIntro: "Hello {name}. Here are your upcoming visits at Casanova.",
        noBookings: "No upcoming appointments. Feel like booking one?",
        bookNow: "Book now",
        with: "with",
        cancel: "Cancel",
        reschedule: "Reschedule",
        cancelConfirmTitle: "Cancel this appointment?",
        cancelConfirmBody: "This is immediate and cannot be undone.",
        cancelConfirmCta: "Yes, cancel",
        keepIt: "Keep the appointment",
        cancelled: "Appointment cancelled.",
        rescheduleTitle: "Pick a new time",
        rescheduleCta: "Confirm new appointment",
        rescheduled: "Appointment rescheduled.",
        rescheduleNoSlots: "No availability with this barber in the next 30 days. Give us a call and we'll find you a time.",
        invalidOrExpired: "This link is no longer valid. Request a new one from the booking page.",
        backToBooking: "Back to booking",
      },
      squarePlaceholder: "Square Booking Widget",
      squareNote: "The booking system will be configured soon.",
      squareCta: {
        eyebrow: "Online booking",
        title: "Book your appointment",
        body: "Pick your service, your barber and your time on our secure Square booking platform. Instant email confirmation.",
        points: [
          "Instant email confirmation",
          "Automatic reminder before your visit",
          "Reschedule or cancel in one click",
        ],
        cta: "Book now",
        opensNew: "Opens in a new tab · Secured by Square",
        phoneLabel: "Or give us a call:",
      },
      hoursTitle: "Hours of Operation",
      hours: {
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
        sunday: "Sunday",
        closed: "Closed"
      },
      addressTitle: "Address",
      address: "56 rue Jean-Talon Ouest",
      neighborhood: "Little Italy, Montreal, QC H2R 2W7",
      paymentsTitle: "Payment Methods",
      faqTitle: "Frequently Asked Questions",
      flow: {
        step: "Step",
        of: "of",
        back: "Back",
        next: "Next",
        confirm: "Confirm booking",
        chooseService: "Choose your service",
        chooseBarber: "Choose your barber",
        anyBarber: "First available",
        chooseTime: "Choose a time",
        yourDetails: "Your details",
        firstName: "First name",
        lastName: "Last name",
        email: "Email",
        phone: "Phone",
        noteOptional: "Note (optional)",
        notePlaceholder: "Preferences, allergies, style you want…",
        minutes: "min",
        from: "from",
        loading: "Loading…",
        noSlots: "No availability for this date. Try another day.",
        changeDate: "Change date",
        summary: "Your appointment",
        with: "with",
        bookingError: "Something went wrong. Please try again.",
        slotTaken: "That time was just booked by someone else. Please pick another slot.",
        confirmedTitle: "Confirmed",
        confirmedBody: "We've emailed you a confirmation. See you soon at Casanova.",
        bookAnother: "Book another appointment",
      },
    },
    
    // FAQ
    faq: [
      {
        q: "Do I need an appointment at Casanova Barbier?",
        a: "Yes, we operate by appointment to guarantee you the best service without waiting. Book online through our booking system."
      },
      {
        q: "How long does a haircut take?",
        a: "A standard haircut (The Cut) takes about 45 minutes. Our signature À la Casanova service takes a full hour."
      },
      {
        q: "What is the À la Casanova service?",
        a: "À la Casanova is our flagship service combining The Cut and The Beard — the complete Casanova experience for men who want the best."
      },
      {
        q: "Why do some services cost more with Pasqualino?",
        a: "Pasqualino has internationally certified training (Vidal Sassoon Toronto, Scoring Barbier Rotterdam, Proraso Italy). His premium rates reflect this unique expertise."
      },
      {
        q: "Where is Casanova Barbier located?",
        a: "We're at 56 rue Jean-Talon Ouest, in the heart of Little Italy, Montreal. Easily accessible by metro (Jean-Talon)."
      },
      {
        q: "What payment methods do you accept?",
        a: "We accept Apple Pay, Google Pay, Interac, Visa, Mastercard, American Express, Discover, and JCB."
      },
      {
        q: "Do you cut children's hair?",
        a: "Yes! Our Bambini service is designed for young men aged 12 and under."
      },
      {
        q: "What is the best barbershop in Little Italy Montreal?",
        a: "Casanova Salon Barbier offers a unique premium experience inspired by Italian tradition. Since 2021, we've been proud to be a reference in the neighborhood."
      },
      {
        q: "Where did Pasqualino train?",
        a: "Pasqualino trained at Vidal Sassoon (Toronto), Gradient (Toronto), Scoring Barbier (Rotterdam), Proraso (Italy), and Bloke Academy (Montreal)."
      }
    ],
    
    // Footer
    footer: {
      tagline: "The art of Italian barbering since 2020.",
      address: "56 rue Jean-Talon Ouest · Montreal, QC · Little Italy",
      copyright: "© 2020–2026 Casanova Salon Barbier. All rights reserved."
    },

    // Contact page
    contact: {
      eyebrow: "Let's stay in touch",
      title: "Come see us",
      intro: "Our door is open. Drop in, call us, or send us a note.",
      addressLabel: "Address",
      addressLine1: "56 rue Jean-Talon Ouest",
      addressLine2: "Little Italy, Montreal, QC H2R 2W7",
      directions: "Open in Google Maps",
      phoneLabel: "Phone",
      phone: "(514) 227-2366",
      emailLabel: "Email",
      email: "ciaociao@casanovamtl.com",
      hoursLabel: "Hours of operation",
      storefrontCaption: "56 Jean-Talon Ouest — under the green awning, in the heart of Little Italy.",
      callCta: "Call",
      emailCta: "Email",
      directionsCta: "Directions",
      days: {
        sun: "Sunday",
        mon: "Monday",
        tue: "Tuesday",
        wed: "Wednesday",
        thu: "Thursday",
        fri: "Friday",
        sat: "Saturday",
      },
    }
  }
};

export default translations;
